import React, { useState } from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { IconButton, styled } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Edit';
import Flex from 'ui/Flex/Flex';
import { GradeMapping } from 'routes/HumanResourcesModule/Settings/HrGrade/helpers/type';
import EditGradeMappingModale from 'routes/HumanResourcesModule/Settings/HrGrade/components/EditGradeMappingModale';

const StyIconButton = styled(IconButton, {
    name: 'StyIconButton',
})(({ theme }) => ({
    margin: '2px',
    padding: '1.5px',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.background,
}));

export default function ActionsCellRenderer({
    value,
}: CellRendererParams<GradeMapping>): React.ReactElement {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Flex align="center" justify="center" alignItems="center">
                <StyIconButton size="small" onClick={() => setShowModal(true)}>
                    <UpdateIcon />
                </StyIconButton>
                {showModal && (
                    <EditGradeMappingModale
                        gradeMapping={value}
                        showModal={showModal}
                        setShowModal={setShowModal}
                    />
                )}
            </Flex>
        </>
    );
}
